//===================防挂机验证框===============

const dialogVisible = {

  state: {
    dialogVisible:false,
  },

  mutations: {

    //重置
    RESET_DIALOG(state){
      state.dialogVisible = false;
    },

    //打开防挂机验证框
    OPEN_DIALOG(state){
      state.dialogVisible = true;
    },

    //关闭防挂机验证框
    CLOSE_DIALOG(state){
      state.dialogVisible = false;
    },

  },

};

export default dialogVisible;
